import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { MissionType } from '../../lib/types/models/mission-type/mission-type'
import { MissionTypeFilter } from '../../lib/types/models/mission-type/mission-type-filter'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionTypes(input: PaginationRequest<MissionTypeFilter> = {}) {
  if (!input.sort) input.sort = { title: 'asc' }

  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.missionTypes.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<MissionType>>()
}
